(function () {
  if (!window.matchMedia('(max-width: 480px)').matches) return;
  window.toggleChatIcon({ display: false });

  const chatObserver = new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType === 1 && node.id === 'gorgias-chat-container') {
          window.toggleChatIcon({ display: false });
        }
      }
    }
  });
  chatObserver.observe(document.body, { childList: true, subtree: true });

  const buyButtons = document.querySelector('.product__buy-buttons');
  let atcButtons   = document.querySelector('product-form .product-form__buttons');
  if (!buyButtons || !atcButtons) return;

  let originalBtn  = atcButtons.querySelector('.product-form__submit');
  let portal       = null;
  let btnObserver  = null;
  let isSticky     = false;
  let atcObserver  = null;
  let ioObserver   = null;
  let refreshTimer = null;

  const _rawToggle = window.toggleChatIcon.bind(window);
  window.toggleChatIcon = ({ display }) => {
    if (display && isSticky) return;
    _rawToggle({ display });
  };

  const syncState = (clonedBtn) => {
    clonedBtn.disabled = originalBtn.disabled;
    const aria = originalBtn.getAttribute('aria-disabled');
    aria !== null
      ? clonedBtn.setAttribute('aria-disabled', aria)
      : clonedBtn.removeAttribute('aria-disabled');
    clonedBtn.classList.toggle('loading', originalBtn.classList.contains('loading'));
  };

  const buildPortalContent = () => {
    originalBtn = atcButtons.querySelector('.product-form__submit');
    portal.innerHTML = atcButtons.innerHTML;

    const clonedBtn = portal.querySelector('.product-form__submit');
    if (clonedBtn) {
      clonedBtn.type = 'button';
      clonedBtn.removeAttribute('id');
      syncState(clonedBtn);

      clonedBtn.addEventListener('click', () => {
        const liveBtn = document.querySelector('product-form .product-form__buttons .product-form__submit');
        if (liveBtn && !liveBtn.disabled && liveBtn.getAttribute('aria-disabled') !== 'true') {
          liveBtn.click();
        }
      });

      btnObserver?.disconnect();
      btnObserver = new MutationObserver(() => syncState(clonedBtn));
      btnObserver.observe(originalBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }

    const isMenobacsEs = !!document.querySelector('.plan-picker-menobacs--es');

    const notes = portal.querySelector('.product-form__notes');
    if (notes) notes.style.display = isMenobacsEs ? 'none' : 'flex';

    const onetime = portal.querySelector('.menobacs-onetime');
    if (onetime) onetime.style.display = isMenobacsEs ? 'none' : '';

    const infoRow = portal.querySelector('[data-menobacs-info]');
    if (infoRow && document.querySelector('plan-picker-menobacs-es[data-es-reverted]')) {
      infoRow.style.display = 'none';
    }

    const payBtn = portal.querySelector('.shopify-payment-button');
    if (payBtn) payBtn.style.display = 'none';
  };

  const isChromeIOS = /CriOS/i.test(navigator.userAgent);

  const enableSticky = () => {
    if (isSticky) return;
    isSticky = true;
    portal = document.createElement('div');
    portal.className = 'product-form__buttons sticky' + (isChromeIOS ? ' is-chrome-ios' : '');
    buildPortalContent();
    document.body.appendChild(portal);
    window.toggleChatIcon({ display: false });
  };

  const disableSticky = () => {
    if (!isSticky) return;
    isSticky = false;
    btnObserver?.disconnect();
    btnObserver = null;
    portal?.remove();
    portal = null;
    window.toggleChatIcon({ display: true });
  };

  const setupObservers = () => {
    atcObserver?.disconnect();
    ioObserver?.disconnect();

    atcObserver = new MutationObserver(() => {
      if (!isSticky) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(buildPortalContent, 50);
    });
    atcObserver.observe(atcButtons, { childList: true, subtree: true, characterData: true });

    ioObserver = new IntersectionObserver(
      ([entry]) => entry.isIntersecting ? disableSticky() : enableSticky(),
      { threshold: 0 }
    );
    ioObserver.observe(atcButtons);
  };

  setupObservers();

  new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType !== 1) continue;
        const newAtc = node.querySelector?.('product-form .product-form__buttons');
        if (!newAtc || newAtc === atcButtons) continue;
        atcButtons = newAtc;
        originalBtn = atcButtons.querySelector('.product-form__submit');
        if (isSticky) buildPortalContent();
        setupObservers();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
